module.exports = __webpack_public_path__ + "img/41d4f87.png";